import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';

export default function UpgradeCancel() {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <div style={{ maxWidth: '500px', margin: '80px auto', textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>↩</div>
        <div style={{ fontSize: '28px', fontWeight: '800', color: '#111827', marginBottom: '12px' }}>
          Upgrade cancelled
        </div>
        <div style={{ fontSize: '15px', color: '#6b7280', marginBottom: '32px' }}>
          No charges were made. You can upgrade anytime from your profile or dashboard.
        </div>
        <button
          style={{ padding: '12px 24px', backgroundColor: '#0052CC', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', fontFamily: 'inherit' }}
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      </div>
    </AppLayout>
  );
}
